module.exports = __webpack_public_path__ + "static/media/docs.cad44d35.jpg";